import { render, staticRenderFns } from "./TaskResultCards.vue?vue&type=template&id=6278466d&scoped=true&"
import script from "./TaskResultCards.vue?vue&type=script&lang=js&"
export * from "./TaskResultCards.vue?vue&type=script&lang=js&"
import style0 from "./TaskResultCards.vue?vue&type=style&index=0&id=6278466d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6278466d",
  null
  
)

export default component.exports